(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["frame-content"]) return;
  try {
    
	$('.content span').addClass('txt-brown');
	$('.disclaimer p span').addClass('txt-brown font-i');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["framing-header"]) return;
  try {
    
$('#hero-gallery strong').addClass('class="font-s"');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-application"]) return;
  try {
    
$('#hero-gallery strong').addClass('class="font-s"');

  } catch(e) { console.error(e); }
})();

})();
